import { axios } from '../request'

const url = 'member_application_photos'

//This is not ready for named lists like the other stores
export default (_app) => {
  return {
    namespaced: true,
    state: {
      listById: {},
      list: [{}],
      loading: false,
      loaded: false,
      errors: [],
      uploading: false,
      progress: 0, // upload progress
    },
    mutations: {
      clearList(state) {
        state.list = [{}]
      },
      setSingle(state, { key, data }) {
        state.list[key] = data
        state.listById[data._id] = data
      },
      setErrors(state, { key, payload }) {
        if (typeof payload !== 'undefined') {
          state.errors[key] = payload
        }
      },
      setLastStatus(state, s) {
        state.status = s
      },
      clearErrors(state) {
        state.errors = []
      },
      loading(state) {
        Object.assign(state, { loaded: false, loading: true })
      },
      loaded(state) {
        Object.assign(state, { loaded: true, loading: false })
      },
      notLoaded(state) {
        Object.assign(state, { loaded: false, loading: false })
      },
      removeFromList(state, k) {
        state.list.splice(k, 1)
        if (state.list.length === 0) {
          state.list = [{}]
        }
      },
      setUploading(state, val) {
        state.uploading = val
      },
      setProgress(state, val) {
        state.progress = val
      },
    },
    actions: {
      clearList(context) {
        context.commit('clearList')
      },
      readFrom(context, data) {
        return new Promise((resolve, reject) => {
          const key = 0
          context.commit('setErrors', { key, payload: {} })
          context.commit('notLoaded')
          context.commit('loading')
          axios
            .get(data.resource + '/' + data.id + '/member_application_photos')
            .then((res) => {
              context.commit('clearErrors')
              context.commit('setSingle', { key, data: res.data.data })
              context.commit('loaded')
              context.commit('setLastStatus', res.status)
            })
            .catch((err) => {
              context.commit('clearErrors')
              context.commit('setSingle', { key, data: {} })
              if (err.response) {
                context.commit('setLastStatus', err.response.status)
                if (err.response.status === 404) {
                  context.commit('loaded')
                } else {
                  context.commit('notLoaded')
                }
              } else {
                context.commit('notLoaded')
              }
              reject(new Error('Could not read item'))
            })
        })
      },
      delete(context, k) {
        return new Promise((resolve, reject) => {
          const id = context.state.list[k]._id
          if (typeof id !== 'undefined') {
            axios
              .delete(`${url}/${id}`)
              .then(() => {
                context.commit('removeFromList', k)
                resolve()
              })
              .catch(() => {
                reject(new Error('failed to delete'))
              })
          } else {
            context.commit('removeFromList', k)
            resolve()
          }
        })
      },
      upload(context, data) {
        return new Promise((resolve, reject) => {
          const headers = { 'Content-Type': 'multipart/form-data' }
          context.commit('setUploading', true)
          axios
            .post(url, data, {
              headers: headers,
              timeout: 0,
              onUploadProgress(progressEvent) {
                context.commit('setProgress', (progressEvent.loaded / progressEvent.total) * 100)
              },
            })
            .then((res) => {
              context.commit('setUploading', false)
              resolve(res)
            })
            .catch((err) => {
              context.commit('setUploading', false)
              context.commit('setProgress', 0)
              // Reject with the real error so the component can branch on
              // err.response.status (413/422/429/401) — issue #214, slice 7.
              reject(err)
            })
        })
      },
    },
  }
}
